import { AuthenticationStrategy } from '@shared/interfaces/authentication-strategies.interface';
import { AuthContext } from '@shared/interfaces/auth-context.interface';
import { ExpectedQueryParams } from '@shared/interfaces/expected-query-params.interface';
import { SessionStorageService } from '@nequi/design-system-lib/logic';
import Keycloak, { KeycloakFlow, KeycloakOnLoad, KeycloakPkceMethod } from 'keycloak-js';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';
import { saveTokens } from '@shared/utils/keycloak-token/keycloak-token';
import {
  RedirectCallbackStrategyConfig,
} from '@shared/services/redirect-callback-strategy/redirect-callback-strategy.config';

export class RedirectCallbackStrategy implements AuthenticationStrategy {
  public canHandle(context: AuthContext): boolean {
    return !!context.params.code && !!context.params.state;
  }

  public async execute(context: AuthContext): Promise<boolean> {
    return await this.tryInitWithRedirect(context.params, context.sessionStorage);
  }

  private async tryInitWithRedirect(
    params: ExpectedQueryParams,
    sessionStorageService: SessionStorageService,
  ): Promise<boolean> {
    if (!params.code || !params.state) return false;

    const keycloak: Keycloak = getKeycloakInstance();

    window.history.replaceState({}, document.title, window.location.pathname);

    await keycloak.init({
      pkceMethod: RedirectCallbackStrategyConfig.pkceMethod as KeycloakPkceMethod,
      flow: RedirectCallbackStrategyConfig.flow as KeycloakFlow,
      checkLoginIframe: RedirectCallbackStrategyConfig.checkLoginIframe,
      onLoad: RedirectCallbackStrategyConfig.loginRequired as KeycloakOnLoad,
    });

    saveTokens(sessionStorageService);
    return true;
  }
}
